import { request } from './http';

const homeQueueInflight = new Map();

export async function getDueRecords(email) {
    return request('/compliance/due-records', {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  }

export async function getHomeQueueRecords(email) {
    const normalizedEmail = String(email || '').trim().toLowerCase();
    if (homeQueueInflight.has(normalizedEmail)) {
      return homeQueueInflight.get(normalizedEmail);
    }

    const promise = request('/compliance/home-queue-records', {
      method: 'POST',
      body: JSON.stringify({ email: normalizedEmail }),
    }).finally(() => {
      homeQueueInflight.delete(normalizedEmail);
    });

    homeQueueInflight.set(normalizedEmail, promise);
    return promise;
  }

export async function getManagedHomeQueueRecords() {
    return request('/compliance/managed-home-queue', {
      method: 'POST',
      body: JSON.stringify({}),
    });
  }

export async function getCalendarRecords(email, window) {
    const normalizedEmail = String(email || '').trim().toLowerCase();
    return request('/compliance/calendar-records', {
      method: 'POST',
      body: JSON.stringify({
        email: normalizedEmail,
        windowStart: window?.start || null,
        windowEnd: window?.end || null
      }),
    });
  }

export async function getOverdueRecords(email) {
    return request('/compliance/overdue-records', {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  }

export async function getCompletedRecords(email) {
    return request('/compliance/completed-records', {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  }

export async function getAllRecords(email) {
    return request('/compliance/all-records', {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  }

export async function getDashboardData(email) {
    return request('/dashboard/data', {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  }

export const complianceRecordsApi = {
  getDueRecords,
  getHomeQueueRecords,
  getManagedHomeQueueRecords,
  getCalendarRecords,
  getOverdueRecords,
  getCompletedRecords,
  getAllRecords,
  getDashboardData,
};

